module.exports = __webpack_public_path__ + "static/joe-previte-9b24798c84a841d896870433e209711e.png";